import { Events } from '@/behaviour/tooltipster/events'
import { $ } from '@/libs/jquery/index'
import { getTooltipster } from '@/libs/tooltipster/index'

export const baseSelector = '.tooltip'

export const initilaizedSelector = '.tooltipstered'

export class Tooltipster {

  private selectors: ISelectors = {
    base: baseSelector,
    initilaized: initilaizedSelector,
  }

  constructor() {
    $(() => {
      const init = () => {
        $(`${this.selectors.base}:not(${this.selectors.initilaized})`).each((index, elem) => {
          const $tooltip: JQuery = $(elem)

          // показывать тултип по клику или при наведении
          const trigger: string = $tooltip.data('tooltipTrigger') || 'click'
          getTooltipster().then(() => {
            $tooltip.tooltipster({
              animation: 'fade',
              contentAsHTML: true,
              delay: 200,
              maxWidth: 335,
              theme: 'tooltipster-shadow',
              trigger,
            })
          })
        })
      }

      const destroy = () => {
        getTooltipster().then(() => {
          $(`${this.selectors.base}${this.selectors.initilaized}`).tooltipster('destroy')
        })
      }

      $(document).on(Events.Reinit, () => {
        // С небольшой задержкой для потенциальних проблем неготовности ДОМа
        setTimeout(() => {
          destroy()
          // Не реинициализируется сразу
          setTimeout(() => {
            init()
          }, 100)
        }, 100)
      })

      init()
    })
  }
}
